import { css } from '@emotion/react'
import { Flow, Icon, Text, Theme, useTheme } from 'bold-ui'

import { TileSourceError, TileSourceErrorKind } from './map-tile-source'

interface LeafletMapErrorBoundaryProps {
  error: TileSourceError | null
}

interface ErrorContent {
  title: string
  message: string
}

const ERROR_CONTENT: Record<TileSourceErrorKind, ErrorContent> = {
  timeout: {
    title: 'Mapa indisponível',
    message: 'O serviço de mapas demorou para responder. Tente novamente em alguns instantes.',
  },
  network: {
    title: 'Mapa indisponível',
    message: 'Não foi possível conectar ao serviço de mapas. Tente novamente em alguns instantes.',
  },
  server: {
    title: 'Não foi possível carregar o mapa',
    message: 'Ocorreu um erro no serviço de mapas. Contate o suporte técnico caso o problema persista.',
  },
  unknown: {
    title: 'Não foi possível carregar o mapa',
    message: 'Ocorreu um erro inesperado. Contate o suporte técnico caso o problema persista.',
  },
}

export function LeafletMapErrorBoundary(props: Readonly<LeafletMapErrorBoundaryProps>) {
  const { error } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  if (!error) return null

  const { title, message } = ERROR_CONTENT[error.kind]

  return (
    <div css={styles.overlay}>
      <Flow direction='vertical' gap={0.5} justifyItems='center'>
        <Icon icon='exclamationTriangleOutline' fill='alert' size={2} />
        <Text fontWeight='bold'>{title}</Text>
        <Text>{message}</Text>
      </Flow>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  overlay: css`
    position: absolute;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.pallete.surface.background};
  `,
})
